export const DEFAULT_ENV_VALUES = Object.freeze({
  BUCKET_URL: 'https://cdn.memooria.org'
})

function hasOwnProperty(value, propertyName) {
  return Object.prototype.hasOwnProperty.call(value, propertyName)
}

function readImportMetaEnv(variableName) {
  try {
    if (typeof import.meta === 'undefined' || !import.meta.env) {
      return undefined
    }

    if (hasOwnProperty(import.meta.env, variableName)) {
      return import.meta.env[variableName]
    }

    const viteVariableName = `VITE_${variableName}`
    if (hasOwnProperty(import.meta.env, viteVariableName)) {
      return import.meta.env[viteVariableName]
    }
  } catch (error) {
    return undefined
  }

  return undefined
}

function readProcessEnv(variableName) {
  const currentProcess = typeof globalThis !== 'undefined' ? globalThis.process : undefined

  if (!currentProcess || !currentProcess.env) {
    return undefined
  }

  if (!hasOwnProperty(currentProcess.env, variableName)) {
    return undefined
  }

  return currentProcess.env[variableName]
}

function normalizeValue(value) {
  return typeof value === 'string' ? value : undefined
}

export const getVar = (variableName, fallbackValue = DEFAULT_ENV_VALUES[variableName]) => {
  const importMetaValue = normalizeValue(readImportMetaEnv(variableName))
  if (typeof importMetaValue !== 'undefined') {
    return importMetaValue
  }

  const processValue = normalizeValue(readProcessEnv(variableName))
  if (typeof processValue !== 'undefined') {
    return processValue
  }

  const defaultValue = normalizeValue(fallbackValue)
  return typeof defaultValue !== 'undefined' ? defaultValue : ''
}

export const EnvVariablesLoader = {
  getVar
}

export default EnvVariablesLoader
